import React, { useMemo } from 'react';
import { filterRoutes } from 'utils/accessManager/index';
import useUser from 'utils/useUser';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from 'router/routes';
import Logo from 'assets/img/header.svg';

import { headerLinks } from './data';
import s from './styles.module.scss';
import DesktopHeader from './desktop';
import MobileHeader from './mobile';
import { useBadge } from './use-badge';

interface IProps {
  disableNavigation?: boolean;
}

const AppHeader: React.FC<IProps> = ({ disableNavigation }) => {
  const user = useUser();
  const location = useLocation();

  const isSmsDashboard = location.pathname === Routes.smsDashboard;

  const { hasMessages } = useBadge({
    canLoadCount: user.hasSmsRole && !isSmsDashboard,
  });

  const { isTurkUserRole, isPatient, isMobileDevice } = user;

  const homeUrl = isTurkUserRole ? Routes.turkDashboard : Routes.dashboard;

  const showNavigation = !disableNavigation && !isPatient && !isTurkUserRole;

  const filteredLinks = useMemo(() => {
    const groups = headerLinks({ showSmsBadge: hasMessages }).map((group) => ({
      label: group.label,
      dataCy: group.dataCy,
      showBadge: group.showBadge,
      links: group.exclude
        ? group.links.map((linkGroup) => linkGroup)
        : group.links.map((linkGroup) => filterRoutes(user, linkGroup)),
    }));

    return groups.filter((group) => group.links.length);
  }, [headerLinks, hasMessages]);

  if (location.pathname.includes(Routes.ccmConsent(''))) return <></>;

  return (
    <header className={s.header} id="app-header">
      <Link data-cy="logged-in-logo" to={homeUrl}>
        <img src={Logo} alt="logo" width={103} height={40} />
      </Link>

      {isMobileDevice ? (
        <div className={s.mobile}>
          <MobileHeader links={filteredLinks} showNavigation={showNavigation} />
        </div>
      ) : (
        <div className={s.desktop}>
          <DesktopHeader
            links={filteredLinks}
            showNavigation={showNavigation}
          />
        </div>
      )}
    </header>
  );
};

export default AppHeader;
